import isBlank from '../../../Common/Utils/Blank';

const ValidateAdUnitType = (values) => {
  const errors = { ad_units: null };

  if (values.bordeaux && values.ad_units) {
    values.ad_units.forEach((ad_unit, index) => {
      if (isBlank(values.ad_units[index].type)) {
        errors.ad_units = { type: 'Ad Unit type is required' };
      }
    });
  }

  return errors;
}

export default ValidateAdUnitType;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Helpers/ValidateAdUnitType.tsx